import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {catchError, concatMap, map, switchMap, withLatestFrom} from 'rxjs/operators';
import {EMPTY, of} from 'rxjs';
import { CheckLicenseActionTypes, CheckLicenseActions } from '../actions/check-license.actions';
import * as fromStore from '../../../store';
import * as featureActions from '../../index';
import {LicenseMgtService} from '../../../services/license-mgt.service';



@Injectable()
export class CheckLicenseEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private licenseMgtService = inject(LicenseMgtService);

  constructor() {}

  GetCheckLicenses$ = createEffect(() => this.actions$.pipe(
    ofType(CheckLicenseActionTypes.GetCheckLicenses),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const payload = { ...action.payload, otp: user.otp };
      return this.licenseMgtService.CheckLicense(payload).pipe(
        map((res: any) => {
          if (res.result && !res.errmsg) {
            return new featureActions.LoadCheckLicenses(res.msg.body);
          } else {
            return new featureActions.ClearCheckLicenses();
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => {
          return of(new featureActions.ClearCheckLicenses());
        })
      );
    })
  ));



}
